import { render } from "./SupportEntryDialog.vue?vue&type=template&id=10a36528&scoped=true"
import script from "./SupportEntryDialog.vue?vue&type=script&lang=js"
export * from "./SupportEntryDialog.vue?vue&type=script&lang=js"

import "./SupportEntryDialog.vue?vue&type=style&index=0&id=10a36528&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a36528"]])

export default __exports__